document.addEventListener('DOMContentLoaded', function() { 
document.addEventListener('variant:changed', function(event) {
});

const variantsSelect = document.querySelector(".variants__select");
if (variantsSelect) {
   variantsSelect.addEventListener("change", function () {
     let scriptElement = document.createElement("script"); 
      scriptElement.setAttribute("src", "https://upstream.heidipay.com/sdk/heidi-upstream-lib.js"); 
      scriptElement.setAttribute("type", "text/javascript"); 
      scriptElement.setAttribute("async", "false"); 
      document.body.append(scriptElement); 
  })
}

const multipleVariantsSelect = document.querySelector(".multiple-variants__select");
if (multipleVariantsSelect) {
   multipleVariantsSelect.addEventListener("change", function () {
     let scriptElement = document.createElement("script"); 
      scriptElement.setAttribute("src", "https://upstream.heidipay.com/sdk/heidi-upstream-lib.js"); 
      scriptElement.setAttribute("type", "text/javascript"); 
      scriptElement.setAttribute("async", "false"); 
      document.body.append(scriptElement); 
  })
}
});
